import React, { createContext, useCallback, useMemo, useState } from 'react'

const SELETED_SETTINGS_MODAL_INITIAL_STATE = {
  modalAction: null,
  initialSetupCompany: null,
  initialSetupType: null,
  headerBackButtonLabel: null,
}

export const SettingsModalVisibilityContext = createContext({})

/**
 * Provide the controls to show/hide the engage settings modals in EngageSettingsModals.js
 */
function SettingsModalsVisibilityProvider(props) {
  const { children } = props // eslint-disable-line react/prop-types

  const [openedSettingsModal, setOpenedSettingsModal] = useState(SELETED_SETTINGS_MODAL_INITIAL_STATE)

  const hideSettingsModal = useCallback(() => setOpenedSettingsModal(SELETED_SETTINGS_MODAL_INITIAL_STATE), [])

  const openSettingsModal = useCallback(
    ({
      modalAction, // required for opening the modal
      initialSetupCompany = null, // customer id when opening the modal
      initialSetupType = null, // GLOBAL or SELECT_COMPANY (defined in DefaultSettingsSetup/constants.js), only necessary if you need to open the modal with 'selected company' radio selected but no company selected in the dropdown
      headerBackButtonLabel = null, // FormattedMessage id, label to show on the back button on the top of the modal, e.g. 'Back to modal name'
    }) => setOpenedSettingsModal({ modalAction, initialSetupCompany, initialSetupType, headerBackButtonLabel }),
    [],
  )

  const provided = useMemo(
    () => ({
      openedSettingsModal,
      hideSettingsModal,
      openSettingsModal,
    }),
    [openedSettingsModal, hideSettingsModal, openSettingsModal],
  )

  return <SettingsModalVisibilityContext.Provider value={provided}>{children}</SettingsModalVisibilityContext.Provider>
}

export default SettingsModalsVisibilityProvider
